<template>
  <div class="movie-card movie-card-second">
    <div class="content-card">
      <img :src="image" :alt="alt">
      <span class="shadow-c"></span>
      <div class="content w-100" data-slot="p-1">
        <div class="px-2">
          <slot name="p-1">
            <h1>Lorem ipsum dolor sit amet, consectetur adipisicing elit</h1>
          </slot>
        </div>
        <i class="bi d-block text-center bi-chevron-down"></i>
      </div>

    </div>

    <div class="watch-card" data-slot="p-2">
      <div class="content">
        <slot name="p-2"></slot>
      </div>
    </div>


  </div>
</template>

<script>

import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card912",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  }
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  transition: all .5s;
  user-select: none;
}

.movie-card {
  width: 100%;
  height: 500px;
  border-radius: 35px;
  position: relative;
  box-shadow: 0 0 50px #0F274D;
}

.movie-card-second {
  margin-top: 50px;
}


.movie-card .content-card,
.movie-card .watch-card {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 35px;
  overflow: hidden;
  cursor: pointer;
  z-index: 100;
}

.movie-card .watch-card .content {
  bottom: 0 !important;
}


.movie-card .watch-card {
  background: var(--primary);
  z-index: 1;
}


.movie-card-second .watch-card {
  background: var(--primary);
}

.movie-card .watch-card .content {
  position: absolute;
  left: 50%;
  bottom: 15px;
  transform: translate(-50%, 0%);
  border: none;
  outline: none;
  background: none;
  color: var(--dark);
  text-transform: uppercase;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
}


.movie-card-second .content-card {
  top: -50px;
}


.movie-card .content-card:hover {
  top: -50px;
}

.movie-card-second .content-card:hover {
  top: 0px;
}

.movie-card .content-card:hover img {
  transform: scale(1.2);
}

.movie-card-second .content-card img {
  transform: scale(1.2);
}

.movie-card-second .content-card:hover img {
  transform: scale(1);
}

.movie-card .content-card img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}


.movie-card .content-card .shadow-c {
  width: 100%;
  height: 170px;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #0F274D;
  box-shadow: 0 0 10px 20px #0F274D;
  filter: blur(10px);
}

.movie-card-second .content-card .shadow-c {
  background: #111;
  box-shadow: 0 0 10px 20px #111;
}


.movie-card .content-card .content {
  position: absolute;
  color: #eee;
  bottom: 20px;
}

.movie-card .content-card .content .bi-chevron-down {
  position: relative;
  margin-top: 5px;
}


</style>